// DS: MO 4.1.5
import React from 'react';
import { useTranslation } from 'react-i18next';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import { Section } from '@wix/da-a11y/pkg/components/headings/tagWrappers';
import FragmentsIcon from '@wix/da-ds/pkg/Icons/24x24/Fragments';
import SolidButton from '@wix/da-ds/pkg/Buttons/SolidButton';
import DaDreamupLogoAndText from '@wix/da-ds/pkg/DaDreamupLogoAndText';
import { first } from '../../../../utils/fp';
import Dumbo from '../../../../DeviationViews/Dumbo';
import s from './DreamupPromo.scss';
const DreamupPromo = ({ block: { deviations = [] } })=>{
    const { t } = useTranslation();
    const deviation = first(deviations);
    return /*#__PURE__*/ React.createElement(Section, {
        className: s['root']
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['top-section']
    }, deviation && /*#__PURE__*/ React.createElement(Dumbo, {
        className: s['deviation'],
        deviation: deviation,
        width: 276,
        height: 224,
        "aria-hidden": "true"
    }), /*#__PURE__*/ React.createElement(Heading, {
        className: s['heading']
    }, t('sidebar.dreamupPromo.heading')), /*#__PURE__*/ React.createElement("p", {
        className: s['description']
    }, t('sidebar.dreamupPromo.description'))), /*#__PURE__*/ React.createElement("div", {
        className: s['divider']
    }), /*#__PURE__*/ React.createElement("div", {
        className: s['bottom-section']
    }, /*#__PURE__*/ React.createElement(DaDreamupLogoAndText, {
        className: s['logo'],
        "aria-label": t('sidebar.dreamupPromo.logo.a11y.label')
    }), /*#__PURE__*/ React.createElement(SolidButton, {
        variant: "main",
        size: "large",
        icon: FragmentsIcon
    }, t('sidebar.dreamupPromo.button.label'))));
};
DreamupPromo.displayName = 'DreamupPromo';
export default DreamupPromo;
